import { DateTime } from 'luxon'

/** An ISO 8601 date bound as the store-local date, with the time only when it is not midnight; any other text is returned as given. */
export const formatFieldIssueLimit = (limit: string): string => {
  const parsed = DateTime.fromISO(limit, { setZone: true })
  const isMidnight = parsed.hour === 0 && parsed.minute === 0
  const format = isMidnight ? 'MMM d, yyyy' : 'MMM d, yyyy h:mm a'

  return parsed.isValid ? parsed.toFormat(format) : limit
}
